import React from "react"
import {Typography} from "@mui/material";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";


interface Props {
    children?: string,
    propertyName?: string,
    label?: string,
    sx?: any
    metadataId?: string
}

function CCOParagraph(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    if (props.children && props.children.length > 0) {
        return <Typography paragraph={true} {...metaDataProperty(isPreview, props.propertyName, props.metadataId)} {...props.sx}>{props.label} {props.children}</Typography>
    } else return <></>
}

export default CCOParagraph